import React, { useState } from "react"

import DatePicker from "react-datepicker"
import { Row, Col } from "react-bootstrap"

import Warning from "../../../images/icons/wdn-warning.png"

import { PAST_EXPERIENCE_FORM_SUBMIT } from "../actions/professionalAction"

import CheckBox from "../../input/checkbox"
import TextArea from "../../input/textarea"
import InputTextBox from "../../input/input-text-box"

const PastExpInputForm = props => {
  const { experienceFormData, setExperienceFormData, setAddPastExp } = props
  const [error, setError] = useState({})

  const handleCompanyNameChange = e => {
    setExperienceFormData({ ...experienceFormData, companyName: e })
  }

  const handleEmailChange = e => {
    setExperienceFormData({ ...experienceFormData, email: e })
  }

  const handlePhoneChange = e => {
    setExperienceFormData({ ...experienceFormData, phone: e })
  }

  const handlePositionChange = e => {
    setExperienceFormData({ ...experienceFormData, position: e })
  }

  const handleAddressChange = e => {
    setExperienceFormData({ ...experienceFormData, address: e })
  }

  const handleToDateChange = e => {
    setError({ ...error })
    delete error["ended_on"]

    if (e < experienceFormData.from) {
      setError({
        ...error,
        ended_on: "To date can't be earlier than from date.",
      })
    }
    setExperienceFormData({ ...experienceFormData, to: e })
  }

  const handleFromDateChange = e => {
    setError({ ...error })
    delete error["started_on"]

    var today = new Date()
    if (e > experienceFormData.to) {
      setError({
        ...error,
        started_on: "From date can't be later than to date.",
      })
    }
    if (e > today) {
      setError({
        ...error,
        started_on: "From date can't be later than today's date.",
      })
    }

    setExperienceFormData({ ...experienceFormData, from: e })
  }

  const handleRunningChange = e => {
    setError({})
    setExperienceFormData({
      ...experienceFormData,
      to: "",
      running: !experienceFormData.running,
    })
  }

  const handleDescriptionFieldChange = e => {
    setExperienceFormData({
      ...experienceFormData,
      description: e.target.value,
    })
  }

  const handleFocus = () => {
    setError({})
  }

  const [isLoading, setIsLoading] = useState(false)

  const handlePastExperienceFormSubmit = e => {
    setIsLoading(true)
    e.preventDefault()
    try {
      const id = JSON.parse(localStorage.getItem("user")).id
      PAST_EXPERIENCE_FORM_SUBMIT(
        id,
        setAddPastExp,
        experienceFormData,
        setError,
        setIsLoading
      )
    } catch (error) { }
  }

  return (
    <>
      <h1>Add Experience</h1>
      <form onSubmit={handlePastExperienceFormSubmit}>
        <Row>
          <Col>
            <InputTextBox
              value={experienceFormData.companyName}
              label="Company Name*"
              onFocus={handleFocus}
              onChange={handleCompanyNameChange}
              placeholder="Company Name"
              class={error.company && "error"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextBox
              value={experienceFormData.email}
              label="Company Email*"
              onFocus={handleFocus}
              onChange={handleEmailChange}
              placeholder="Company Email"
              class={error.email && "error"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextBox
              value={experienceFormData.phone}
              label="Company Mobile/Phone"
              onFocus={handleFocus}
              onChange={handlePhoneChange}
              placeholder="Mobile/Phone"
              class={error.phone && "error"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextBox
              value={experienceFormData.position}
              label="Position*"
              onFocus={handleFocus}
              onChange={handlePositionChange}
              placeholder="Accountant"
              class={error.position && "error"}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextBox
              value={experienceFormData.address}
              label="Address"
              onChange={handleAddressChange}
              placeholder="Address"
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="form-group">
              <label htmlFor="fromDate" className="d-block">
                From*
              </label>
              <DatePicker
                name="fromDate"
                showMonthYearPicker
                selected={experienceFormData.from}
                onFocus={handleFocus}
                placeholderText="dd-mm-yyyy"
                className={
                  error.started_on ? "error-input form-control" : "form-control"
                }
                onChange={handleFromDateChange}
                dateFormat="MM-yyyy"
              />
            </div>
          </Col>
          <Col>
            <div className="form-group">
              <label htmlFor="toDate" className="d-block">
                To
              </label>
              <DatePicker
                name="toDate"
                showMonthYearPicker
                selected={experienceFormData.to}
                placeholderText="dd-mm-yyyy"
                className={
                  error.ended_on ? "error-input form-control" : "form-control"
                }
                onChange={handleToDateChange}
                disabled={experienceFormData.running}
                dateFormat="MM-yyyy"
              />
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <CheckBox
              label="Running"
              checked={experienceFormData.running}
              onChange={handleRunningChange}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <TextArea
              value={experienceFormData.description}
              label="About*"
              onFocus={handleFocus}
              placeholder="Describe your role"
              onChange={handleDescriptionFieldChange}
              class={error.description && "error"}
            />
          </Col>
        </Row>
        {error &&
          Object.keys(error)
            .slice(0, 1)
            .map((key, value) => {
              if (experienceFormData.companyName === "") {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    Company Name is required.
                  </div>
                )
              } else if (experienceFormData.email === "") {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    Company Email is required.
                  </div>
                )
              } else if (experienceFormData.position === "") {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    Position is required.
                  </div>
                )
              } else if (experienceFormData.from === "") {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    From is required.
                  </div>
                )
              } else if (experienceFormData.description === "") {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    About is required.
                  </div>
                )
              } else {
                return (
                  <div
                    key={value}
                    className="alert-block mb-4 d-flex align-items-center"
                  >
                    <img src={Warning} className="mr-3" alt="wdn-warning" />
                    {error[key]}
                  </div>
                )
              }
            })}
        <Row>
          <Col>
            <button
              type="submit"
              className="btn w-100 btn-custom rounded primary"
              disabled={isLoading}
            >
              {isLoading ? "Processing" : "Save"}
            </button>
          </Col>
        </Row>
      </form>
    </>
  )
}

export default PastExpInputForm
